
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipTugboat as ObiShipTugboatElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-tugboat.js';
 
 
 

 
 export const ObiShipTugboat = createComponent({
   react: React,
   tagName: 'obi-ship-tugboat',
   elementClass: ObiShipTugboatElement,
   events: {
     
   }
  });
 
 